<template>
    <b-container fluid>
        <admin-preloader :show="loading" />
        <admin-breadcrumb name="METRC Items" />
        <b-row>
            <b-col cols="12">
                <admin-panel title="Items" with-footer>
                    <admin-items-table :items="items" />
                    <template v-slot:header-right>
                        <div class="mt-n2 d-flex flex-wrap">
                            <b-form-input class="w-auto mr-2 mt-2" v-model="filters.item_name"
                                placeholder="Item Name" />
                            <b-form-input class="w-auto mr-2 mt-2" v-model="filters.company_name"
                                placeholder="Company Name" />
                            <b-form-input class="w-auto mr-2 mt-2" v-model="filters.license_number"
                                placeholder="License Number" />
                        </div>
                    </template>
                    <template v-slot:footer>
                        <b-pagination v-model="page" :total-rows="total_in_pages" :per-page="per_page"
                            @change="loadItems" align="center" class="admin-pagination mb-0" />
                    </template>
                </admin-panel>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import AdminPreloader from "../components/AdminPreloader";
import AdminBreadcrumb from "../components/AdminBreadcrumb";
import AdminPanel from "../components/AdminPanel";
import AdminItemsTable from "../components/AdminItemsTable";

export default {
    name: "AdminItems",
    components: { AdminItemsTable, AdminPanel, AdminBreadcrumb, AdminPreloader },
    data() {
        return {
            items: [
                { id: 1, name: "Cosmic Kush Cookies", category: "Edible", strain: "Cosmic Kush", qoh: 420 },
                { id: 2, name: "Mango Tango Tincture", category: "Concentrate", strain: "Mango Haze", qoh: 150 },
                { id: 3, name: "Blueberry Bliss Balm", category: "Topical", strain: "Blueberry Kush", qoh: 75 },
                { id: 4, name: "Pineapple Express Pre-Roll", category: "Pre-roll", strain: "Pineapple Express", qoh: 300 },
                { id: 5, name: "Northern Lights Nug", category: "Flower", strain: "Northern Lights", qoh: 500 },
                { id: 6, name: "Lemon Haze Lollipops", category: "Edible", strain: "Lemon Haze", qoh: 200 },
                { id: 7, name: "Grape Ape Gummies", category: "Edible", strain: "Grape Ape", qoh: 350 },
                { id: 8, name: "Skywalker OG Shatter", category: "Concentrate", strain: "Skywalker OG", qoh: 100 },
                { id: 9, name: "Lavender Kush Lotion", category: "Topical", strain: "Lavender Kush", qoh: 80 },
                { id: 10, name: "Jack Herer Joint", category: "Pre-roll", strain: "Jack Herer", qoh: 250 }
            ],
            loading: false,
            page: 1,
            per_page: 10,
            total_in_pages: 20,
            filters: {
                item_name: "",
                company_name: "",
                license_number: ""
            }
        }
    },
    methods: {
        loadItems(page = 1) {
            // query endpoint with pagination and filters
            this.page = page;
        }
    },
    created() {
        this.loadItems();
    }
}
</script>
